import { SxProps, Theme } from "@mui/material";

export const styles: Record<string, SxProps<Theme>> = {
  sectionTitle: {
    fontSize: "13px",
    lineHeight: "20px",
    fontWeight: 800,
    textTransform: "uppercase",
  },
  buttonGroup: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "1rem",
  },
};
